module.exports = __webpack_public_path__ + "static/media/6.a8395432.svg";